/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type DefaultAlertCardDataAlert_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    status: Types.TaskNotificationStatus
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type DefaultAlertCardDataAlert_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_StopAccessibilityDownvotedByDrivers_Fragment =
  {
    __typename?: 'StopAccessibilityDownvotedByDrivers'
    status: Types.TaskNotificationStatus
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type DefaultAlertCardDataAlert_StopActivationFailedNotification_Fragment =
  {
    __typename?: 'StopActivationFailedNotification'
    status: Types.TaskNotificationStatus
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type DefaultAlertCardDataAlert_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    status: Types.TaskNotificationStatus
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type DefaultAlertCardDataAlert_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_TripPrebookingNoAssignment_Fragment = {
  __typename?: 'TripPrebookingNoAssignment'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_VehicleAvailabilityNotification_Fragment =
  {
    __typename?: 'VehicleAvailabilityNotification'
    status: Types.TaskNotificationStatus
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type DefaultAlertCardDataAlert_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlert_VehicleSurveillanceNotification_Fragment =
  {
    __typename?: 'VehicleSurveillanceNotification'
    status: Types.TaskNotificationStatus
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type DefaultAlertCardDataAlert_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  status: Types.TaskNotificationStatus
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type DefaultAlertCardDataAlertFragment =
  | DefaultAlertCardDataAlert_HubServiceNotification_Fragment
  | DefaultAlertCardDataAlert_IvcTaskNotification_Fragment
  | DefaultAlertCardDataAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | DefaultAlertCardDataAlert_PassengerUnbuckled_Fragment
  | DefaultAlertCardDataAlert_RoadBlockageTaskNotification_Fragment
  | DefaultAlertCardDataAlert_ShiftDeviationNotification_Fragment
  | DefaultAlertCardDataAlert_StopAccessibilityDownvotedByDrivers_Fragment
  | DefaultAlertCardDataAlert_StopActivationFailedNotification_Fragment
  | DefaultAlertCardDataAlert_StopAreaMissingActiveStopsNotification_Fragment
  | DefaultAlertCardDataAlert_StopDownVotedByDrivers_Fragment
  | DefaultAlertCardDataAlert_StopPotentiallyUnreachable_Fragment
  | DefaultAlertCardDataAlert_StopValidationFailed_Fragment
  | DefaultAlertCardDataAlert_TimeManagementNotification_Fragment
  | DefaultAlertCardDataAlert_TripPrebookingNoAssignment_Fragment
  | DefaultAlertCardDataAlert_VehicleAvailabilityNotification_Fragment
  | DefaultAlertCardDataAlert_VehicleIncidentNotification_Fragment
  | DefaultAlertCardDataAlert_VehicleSurveillanceNotification_Fragment
  | DefaultAlertCardDataAlert_VehicleWaypointAttendance_Fragment

export const DefaultAlertCardDataAlertFragmentDoc = gql`
    fragment DefaultAlertCardDataAlert on TaskNotification {
  status
  assigned {
    backofficeUserId
  }
}
    `
